<template>
    <div>
        <div class="body-overlay" id="body-overlay"></div>
        <SearchPopup />
        <Header />
        <Banner />
        <Intro />
        <WhoWeAre />
        <ProjectsDone />
        <AboutArea />
        <Team />
        <CTA />
        <Testimonial class="bg-sky pd-bottom-240" />
        <Quote />
        <Client />
        <Instagram />
        <Footer />
    </div>
</template>

<script>
    import SearchPopup from '@/components/layout/SearchPopup.vue'
    import Header from '@/components/layout/Header.vue'
    import Banner from '@/components/page/about/Banner.vue'
    import Intro from '@/components/page/about/Intro.vue'
    import AboutArea from '@/components/page/about/AboutArea.vue'
    import Client from '@/components/page/home/Client.vue'
    import Instagram from '@/components/page/home/Instagram.vue'
    import Footer from '@/components/layout/Footer.vue'

    export default {
        name: "Service",
        components: {
            SearchPopup,
            Header,
            Banner,
            Intro,
            AboutArea,

            Client,
            Instagram,
            Footer
        },
    }
</script>

<style>
.pd-bottom-240 {
    padding-bottom: 240px;
}
</style>


// WEBPACK FOOTER //
// src/pages/About.vue